/**
 * 复制到剪贴板（移动端 / 内嵌 WebView 兼容）
 *
 * - 优先 Async Clipboard API（需安全上下文 HTTPS 等）
 * - 失败时回退到 textarea + document.execCommand('copy')（多数手机浏览器仍可用）
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  const s = String(text ?? "").trim();
  if (!s || typeof window === "undefined") return false;

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(s);
      return true;
    }
  } catch {
    // 部分 WebView / 权限拒绝 → 走回退
  }

  try {
    const ta = document.createElement("textarea");
    ta.value = s;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "0";
    ta.style.left = "0";
    ta.style.width = "1px";
    ta.style.height = "1px";
    ta.style.padding = "0";
    ta.style.border = "none";
    ta.style.outline = "none";
    ta.style.boxShadow = "none";
    ta.style.background = "transparent";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, s.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
